import { GET_ORGANISATION_DETAILS, GET_ORGANISATION_DETAILS_SUCCESS, GET_ORGANISATION_DETAILS_FAIL } from '../reducers/organisationReducer'

export const getOrganisationDetails = (organisationId) => {
  return {
    types: [GET_ORGANISATION_DETAILS, GET_ORGANISATION_DETAILS_SUCCESS, GET_ORGANISATION_DETAILS_FAIL],
    payload: {
      request: {
        url: `dashboard/organisations/${organisationId}`,
        method: 'GET'
      }
    }
  }
}
